import React from 'react';
import { Layout } from 'antd';

const FooterArea = () => {
  return (
    <Layout.Footer
      style={{
        textAlign: 'center',
        padding: '17px 20px', // Increased from 15px to 17px
        position: 'sticky',
        bottom: 0,
        width: '100%',
        zIndex: 10,
        background: '#001529',
        color: '#ffffff',
        fontSize: '14px',
        overflow: 'hidden',
      }}
    >
      ©{new Date().getFullYear()} nua. All rights reserved.
    </Layout.Footer>
  );
};

export default FooterArea;
